// extracted by mini-css-extract-plugin
export default {"galleryContainer":"gallery_galleryContainer__9hiSD","allIMGS":"gallery_allIMGS__25I6G","containerIMG":"gallery_containerIMG__V6Jq4"};